<script setup lang="ts">
import { contentToTailwindClasses } from "~/utils/helper/tailwind";
import PictureElement from "~/templates/elements/PictureElement.vue";
import CommonLabel from "~/templates/components/CommonLabel.vue";

const props = defineProps([
  "promoBoxBackgroundColor",
  "promoBoxRichText",
  "promoCode",
  "promoBoxIcon",
  "showPromoBox",
]);

const { isMagnoliaEdit } = useMagnoliaContext();
const { pushSuccess, pushError } = useNotifications();
const { getLabels } = useCommonLabels();
const { copySuccess, copyFailed } = getLabels("BWF/shop/shared/", ["copySuccess", "copyFailed"]);

import { useClipboard } from "@vueuse/core";
import { containsImage } from "~/utils/helper/magnolia";

const source = ref(props?.promoCode);
const { copy, isSupported } = useClipboard({ source });
function copyCode() {
  try {
    copy(source?.value);
    pushSuccess(copySuccess);
  } catch (e) {
    pushError(copyFailed);
    console.error(e);
  }
}

const backgroundColor = props?.promoBoxBackgroundColor ?? "deepBlue";
</script>

<template>
  <div v-if="isMagnoliaEdit || showPromoBox">
    <div
      class="flex w-full gap-6 rounded-lg p-4"
      :class="contentToTailwindClasses({ backgroundColor })"
    >
      <div v-if="containsImage(promoBoxIcon)" class="aspect-square h-full w-20 md:w-24">
        <PictureElement :img="promoBoxIcon" img-class="mx-auto w-full h-full object-contain">
        </PictureElement>
      </div>

      <div class="flex w-full flex-col justify-center text-start">
        <div
          class="prose max-w-none hyphens-auto"
          :class="backgroundColor === 'deepBlue' ? 'prose-white' : 'text-base-02'"
        >
          <div v-html="promoBoxRichText" />
        </div>
        <button
          v-if="promoCode && isSupported"
          class="text-link mt-2 flex-shrink place-self-start"
          :class="backgroundColor === 'deepBlue' ? 'text-white' : ''"
          @click="copyCode"
        >
          <CommonLabel path="/BWF/shop/shared/copyCodeButtonLabel" />
        </button>
      </div>
    </div>
  </div>
</template>
